import { Dispatch, RefObject } from "react";
import { AdministrativeLevel, AdministrativeLevels, EarlyWarningTypes, FlatAdmin, FLWDataRefType, HRWDataRefType, HWNDataRefType, LIGDataRefType, LSWDataRefType, MWADataRefType, NTWDataRefType } from "./CreateWarningTypes";
import { useTheme } from "../../context/ThemeContext";
import { ThemeContextType } from "../../context/ContextTypes";
import { APICallNewHRWRequest, APIRequestAddHRWAreaTypes, APIRequestAddHRWTypes, ResponseTypes } from "../../services/APIEarlyWarningService";
import { sriLankaAdministrationLevel } from "./FixedDataSet";

export const flatMap = (data: AdministrativeLevels, selectedArea: string[] = [], depth: number = 0): FlatAdmin[] => {
    const result: FlatAdmin[] = [];

    for(const [code, value] of Object.entries(data)) {
        if (typeof value === "string") {
            result.push({code, name: value, adminLevel: value, depth})
        } else {
            result.push({code, name: value.name, adminLevel: value.adminLevel, depth})

            if (value.children && !selectedArea.includes(code)) {
                const children = flatMap(value.children, selectedArea, depth + 1)
                result.push(...children)
            }
        }
    }
    return result
}

export const paginationList = (data: FlatAdmin[], size: number): FlatAdmin[][] => {
    const result: FlatAdmin[][] = []

    if (size >= data.length) {
        return [data]
    }

    let start = 0

    while (start < data.length) {
        result.push(data.slice(start, start + size))
        start += size
    }

    return result
}

// Calculate field count
export const sideFieldCount = (totalField: number): number => {
    if (totalField > 0) {
        const value = totalField % 2

        if (value === 0){
            return totalField / 2
        } else {
            return (totalField + 1) /2
        }
    } else {
        return totalField
    }
}

export const getThemeColors = (theme: ThemeContextType) => {
        switch (theme.theme) {
            case 'dark':
                return {
                    background: '#00497eff',
                    stroke: 'black',
                    defaultFill: '#EEE',
                    selectStroke: "red",
                    disable: '#a3a3a3',
                    disableStroke: '#4c4c4c'
                };
            case 'light':
                return {
                    background: '#E6F2FF',
                    stroke: 'black',
                    defaultFill: '#EEE',
                    selectStroke: "red",
                    disable: '#a3a3a3',
                    disableStroke: '#4c4c4c'
                };
            case 'colorful':
            default:
                return {
                    background: '#e8f4f8',
                    stroke: 'black',
                    defaultFill: '#EEE',
                    selectStroke: "red",
                    disable: '#a3a3a3',
                    disableStroke: '#4c4c4c'
                }
        }
    }

// export function convertToOffsetDateTime(localDateTimeString: string) {
//     const localDate = new Date(localDateTimeString);
//     const offset = -localDate.getTimezoneOffset();
//     const sign = offset >= 0 ? "+" : "-";
//     const pad = (num: number) => String(Math.floor(Math.abs(num))).padStart(2, "0");

//     const hours = pad(offset / 60);
//     const minutes = pad(offset % 60);

//     const isoString = localDate.toISOString().split('.')[0]; // remove milliseconds
//     return `${isoString}${sign}${hours}:${minutes}`;
// }
export function convertToOffsetDateTime(localDateTimeString: string): string {
    const date = new Date(localDateTimeString);

    const pad = (n: number) => n.toString().padStart(2, '0');

    const year = date.getFullYear();
    const month = pad(date.getMonth() + 1);
    const day = pad(date.getDate());
    const hours = pad(date.getHours());
    const minutes = pad(date.getMinutes());
    const seconds = pad(date.getSeconds());

    const offsetMinutes = -date.getTimezoneOffset();
    const sign = offsetMinutes >= 0 ? '+' : '-';
    const offsetHours = pad(Math.floor(Math.abs(offsetMinutes) / 60));
    const offsetMins = pad(Math.abs(offsetMinutes) % 60);

    return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}${sign}${offsetHours}:${offsetMins}`;
}

export const formatDate = (date: Date): string => {
    const pad = (n: number) => n.toString().padStart(2, "0");
    return (
        date.getFullYear() +
        "-" +
        pad(date.getMonth() + 1) +
        "-" +
        pad(date.getDate()) +
        "T" +
        pad(date.getHours()) +
        ":" +
        pad(date.getMinutes())
    )
}

export const getSeverityColor = (name: string): string => {
    switch (name.toLocaleLowerCase()) {
        case "yellow": return "#ffff00"
        case "amber": return "#ffbf00"
        case "red": return "#ff0000"
        case "white": return "#ffffff"
        case "": return "#00ff00"
        default: return ""
    }
}

// Get next children
export const getNextChildrenSL = (code: string, adminLevels: AdministrativeLevels = sriLankaAdministrationLevel): (AdministrativeLevel & { code: string })[] => {

    for (const [key, value] of Object.entries(adminLevels)) 
    {
        if (key === code) 
        {
            // Found the node, return its children (if any)
            if (!value.children) return []
            return Object.entries(value.children).map(([childCode, child]) => ({
                code: childCode,
                ...child
            }));
        }

        // If the node has children, search recursively
        if (value.children) 
        {
            const result = getNextChildrenSL(code, value.children)
            if (result.length > 0) return result
        }
    }

    // Not found
    return []
}